import $ from 'jquery';
const cookie = require('./cookies');

$(function() {
    if (cookie.get('js_enabled') == false) {
        cookie.set('js_enabled', true, 1);
    }
});
